import {
  LOGIN_ACCENT,
  MOBILE_SHELL_BACKGROUND,
  MOBILE_SHELL_BASE_COLOR,
  mobileLoginBackground,
} from '../../auth/loginDarkTheme';
import { MOBILE_LAYOUT } from '../../../utils/mobileView';

// Shell layout sets header/bottom offsets — omit auth-only safe-area padding.
const { pt: _pt, pb: _pb, ...mobileAppSurface } = mobileLoginBackground;
export const mobileAppBackground = {
  ...mobileAppSurface,
  background: MOBILE_SHELL_BACKGROUND,
  backgroundColor: MOBILE_SHELL_BASE_COLOR,
};

/** Frosted chrome over the graph backdrop (header / bottom nav). */
export const mobileShellChromeSx = {
  background: 'rgba(3, 7, 18, 0.55)',
  backgroundColor: 'transparent',
  backdropFilter: 'blur(20px)',
  WebkitBackdropFilter: 'blur(20px)',
};

export const mobileShellHeaderSx = {
  ...mobileShellChromeSx,
  borderBottom: '1px solid rgba(255, 255, 255, 0.06)',
};

export const MOBILE_APP_HEADER_HEIGHT = MOBILE_LAYOUT.mobileAppHeaderHeight;
export const MOBILE_BOTTOM_NAV_HEIGHT = MOBILE_LAYOUT.mobileBottomNavHeight;
export const MOBILE_FAB_LIFT = MOBILE_LAYOUT.mobileFabLift;

/** Hide scrollbars while keeping touch/scroll behaviour (mobile shell). */
export const mobileHideScrollbarSx = {
  scrollbarWidth: 'none',
  msOverflowStyle: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
    width: 0,
    height: 0,
  },
};

export const mobileAppGlassCard = {
  borderRadius: '16px',
  background: 'linear-gradient(155deg, rgba(0,0,0,0.72) 0%, rgba(3,7,18,0.88) 100%)',
  border: '1px solid rgba(255, 255, 255, 0.09)',
  backdropFilter: 'blur(24px)',
  WebkitBackdropFilter: 'blur(24px)',
  boxShadow: '0 14px 28px rgba(0,0,0,0.42), inset 0 1px 0 rgba(255,255,255,0.06)',
};

export const mobileMetricCardSx = (accent = LOGIN_ACCENT) => ({
  ...mobileAppGlassCard,
  p: 1.35,
  minHeight: 96,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  '& .metric-icon': {
    width: 32,
    height: 32,
    borderRadius: '50%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: `${accent}22`,
    color: accent,
  },
});

export const mobileQuickActionSx = {
  ...mobileAppGlassCard,
  p: 1.15,
  minHeight: 74,
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 0.625,
  cursor: 'pointer',
  transition: 'transform 0.15s ease, border-color 0.15s ease',
  '&:active': { transform: 'scale(0.97)' },
  '&:hover': { borderColor: 'rgba(76, 225, 182, 0.35)' },
};

export const mobileBottomNavSx = {
  position: 'fixed',
  left: 0,
  right: 0,
  bottom: 0,
  zIndex: 1200,
  height: `calc(${MOBILE_BOTTOM_NAV_HEIGHT}px + env(safe-area-inset-bottom))`,
  pb: 'env(safe-area-inset-bottom)',
  borderTop: '1px solid rgba(255, 255, 255, 0.08)',
  ...mobileShellChromeSx,
  display: 'flex',
  alignItems: 'flex-start',
  justifyContent: 'space-around',
  px: 1,
  pt: 0.625,
};

export const mobileSectionTitleSx = {
  color: '#f8fafc',
  fontWeight: 700,
  fontSize: '1rem',
  letterSpacing: '-0.02em',
};

/** Grid nav item label — matches mobile dashboard quick actions */
export const mobileNavGridItemLabelSx = {
  color: '#e2e8f0',
  fontSize: '0.66rem',
  fontWeight: 600,
  textAlign: 'center',
  lineHeight: 1.12,
  px: 0.1,
  letterSpacing: '0.01em',
};

/** Subsection heading inside mobile nav sheets */
export const mobileNavGroupTitleSx = {
  ...mobileSectionTitleSx,
  fontSize: '0.98rem',
  mb: 0.75,
};

export const mobileSectionSubtleSx = {
  color: 'rgba(148, 163, 184, 0.88)',
  fontSize: '0.78rem',
};

/** Flex child that fills remaining dashboard height without growing past the viewport. */
export function getMobileDashboardPanelSx() {
  return {
    flex: '1 1 0',
    minHeight: 0,
    height: 0,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
  };
}

/** Primary scroll region for mobile dashboard room-board views (grid / ultra / calendar). */
export function getMobileDashboardScrollSx() {
  return {
    flex: '1 1 0',
    minHeight: 0,
    height: 0,
    overflowY: 'auto',
    overflowX: 'hidden',
    WebkitOverflowScrolling: 'touch',
    overscrollBehavior: 'contain',
    touchAction: 'pan-y',
    ...mobileHideScrollbarSx,
  };
}
